import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Solution() {
  return <section className="py-10 px-4" data-id="element-185">
      <div className="max-w-4xl mx-auto space-y-14" data-id="element-186">
        {/* Vision */}
        <FadeIn data-id="element-187">
          <div className="text-center" data-id="element-188">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-189">
              <span className="text-yellow-400 mr-2" data-id="element-190">💡</span> Ahora imaginá
              esto…
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mb-4" data-id="element-191">
              Te llega un paciente con dolor.
            </p>
            <p className="text-lg md:text-xl text-slate-300 mb-6" data-id="element-192">
              En lugar de dudar…
            </p>

            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3 max-w-3xl mx-auto mb-8" data-id="element-193">
              <div className="bg-slate-800 p-3 rounded-xl border border-lime-500/30 flex items-center text-sm md:text-base" data-id="element-194">
                <span className="text-lime-500 mr-2" data-id="element-195">✔</span>{' '}
                <span className="text-slate-200" data-id="element-196">Sabés qué evaluar</span>
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-lime-500/30 flex items-center text-sm md:text-base" data-id="element-197">
                <span className="text-lime-500 mr-2" data-id="element-198">✔</span>{' '}
                <span className="text-slate-200" data-id="element-199">Tenés claro el objetivo</span>
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-lime-500/30 flex items-center text-sm md:text-base" data-id="element-200">
                <span className="text-lime-500 mr-2" data-id="element-201">✔</span>{' '}
                <span className="text-slate-200" data-id="element-202">
                  Elegís la técnica correcta
                </span>
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-lime-500/30 flex items-center sm:col-span-2 md:col-span-1 md:col-start-2 text-sm md:text-base" data-id="element-203">
                <span className="text-lime-500 mr-2" data-id="element-204">✔</span>{' '}
                <span className="text-slate-200" data-id="element-205">Aplicás con seguridad</span>
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-lime-500/30 flex items-center sm:col-span-2 md:col-span-1 text-sm md:text-base" data-id="element-206">
                <span className="text-lime-500 mr-2" data-id="element-207">✔</span>{' '}
                <span className="text-slate-200" data-id="element-208">Reevaluás con criterio</span>
              </div>
            </div>

            <p className="text-lg md:text-xl text-slate-300 mb-4" data-id="element-209">
              Y por primera vez…
            </p>
            <p className="text-xl md:text-2xl text-white font-bold bg-slate-800 inline-block px-6 py-3 rounded-2xl border border-cyan-500/30" data-id="element-210">
              <span className="text-cyan-400 mr-2" data-id="element-211">👉</span> Sentís que sabés lo
              que estás haciendo
            </p>
          </div>
        </FadeIn>

        {/* The System */}
        <FadeIn data-id="element-212">
          <div className="max-w-3xl mx-auto" data-id="element-213">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 text-center" data-id="element-214">
              <span className="text-2xl mr-2" data-id="element-215">🧩</span> El sistema que te
              faltaba
            </h2>
            <p className="text-lg md:text-xl text-slate-300 text-center mb-8" data-id="element-216">
              KinesioTapingPro está basado en 3 pilares:
            </p>

            <div className="grid md:grid-cols-3 gap-4 mb-8" data-id="element-217">
              <div className="bg-slate-800 p-5 rounded-2xl border border-slate-700 text-center" data-id="element-218">
                <div className="w-10 h-10 bg-cyan-500/20 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-219">
                  <span className="text-cyan-400 font-bold text-lg" data-id="element-220">1</span>
                </div>
                <h3 className="text-white font-bold" data-id="element-221">Casos reales</h3>
              </div>
              <div className="bg-slate-800 p-5 rounded-2xl border border-slate-700 text-center" data-id="element-222">
                <div className="w-10 h-10 bg-cyan-500/20 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-223">
                  <span className="text-cyan-400 font-bold text-lg" data-id="element-224">2</span>
                </div>
                <h3 className="text-white font-bold" data-id="element-225">Razonamiento clínico</h3>
              </div>
              <div className="bg-slate-800 p-5 rounded-2xl border border-slate-700 text-center" data-id="element-226">
                <div className="w-10 h-10 bg-cyan-500/20 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-227">
                  <span className="text-cyan-400 font-bold text-lg" data-id="element-228">3</span>
                </div>
                <h3 className="text-white font-bold" data-id="element-229">Aplicación directa</h3>
              </div>
            </div>

            <p className="text-xl md:text-2xl text-center text-white font-medium italic" data-id="element-230">
              Es el puente entre lo que sabés… y lo que hacés.
            </p>
          </div>
        </FadeIn>

        {/* What's Inside */}
        <FadeIn data-id="element-231">
          <div className="bg-slate-800/50 rounded-3xl p-6 md:p-10 border border-slate-700" data-id="element-232">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-233">
              <span className="text-2xl mr-2" data-id="element-234">📚</span> ¿Qué vas a encontrar
              dentro?
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-235">
              <div data-id="element-236">
                <h3 className="text-lg md:text-xl text-cyan-400 font-semibold mb-4" data-id="element-237">
                  Casos frecuentes como:
                </h3>
                <ul className="space-y-3" data-id="element-238">
                  <li className="flex items-center text-sm md:text-base text-slate-300 bg-slate-900/50 p-2.5 rounded-lg" data-id="element-239">
                    <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-240"></span>{' '}
                    Dolor cervical por estudio
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300 bg-slate-900/50 p-2.5 rounded-lg" data-id="element-241">
                    <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-242"></span>{' '}
                    Sobrecarga de hombro
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300 bg-slate-900/50 p-2.5 rounded-lg" data-id="element-243">
                    <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-244"></span>{' '}
                    Lumbalgia leve
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300 bg-slate-900/50 p-2.5 rounded-lg" data-id="element-245">
                    <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-246"></span>{' '}
                    Dolor de rodilla
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300 bg-slate-900/50 p-2.5 rounded-lg" data-id="element-247">
                    <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-248"></span>{' '}
                    Gemelos sobrecargados
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300 bg-slate-900/50 p-2.5 rounded-lg" data-id="element-249">
                    <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3" data-id="element-250"></span>{' '}
                    Molestias de muñeca
                  </li>
                </ul>
              </div>

              <div data-id="element-251">
                <h3 className="text-lg md:text-xl text-lime-400 font-semibold mb-4" data-id="element-252">
                  Cada caso incluye:
                </h3>
                <ul className="space-y-3" data-id="element-253">
                  <li className="flex items-center text-sm md:text-base text-slate-300" data-id="element-254">
                    <span className="text-lime-500 mr-3" data-id="element-255">✔</span> Evaluación
                    simple
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300" data-id="element-256">
                    <span className="text-lime-500 mr-3" data-id="element-257">✔</span> Razonamiento
                    clínico
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300" data-id="element-258">
                    <span className="text-lime-500 mr-3" data-id="element-259">✔</span> Objetivo del
                    tape
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300" data-id="element-260">
                    <span className="text-lime-500 mr-3" data-id="element-261">✔</span> Aplicación
                    sugerida
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300" data-id="element-262">
                    <span className="text-lime-500 mr-3" data-id="element-263">✔</span> Errores
                    frecuentes
                  </li>
                  <li className="flex items-center text-sm md:text-base text-slate-300" data-id="element-264">
                    <span className="text-lime-500 mr-3" data-id="element-265">✔</span> Qué reevaluar
                    después
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-10 text-center" data-id="element-266">
              <Button href="#compra" variant="secondary" className="text-lg px-8 py-3" data-id="element-267">
                Accedé ahora a los casos
              </Button>
            </div>
          </div>
        </FadeIn>

        {/* Key Insight */}
        <FadeIn data-id="element-268">
          <div className="bg-gradient-to-r from-cyan-900/40 to-blue-900/40 border border-cyan-500/30 rounded-3xl p-6 md:p-10 text-center shadow-2xl" data-id="element-269">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-5" data-id="element-270">
              <span className="text-yellow-400 mr-2" data-id="element-271">⚠️</span> Y esto es lo más
              importante
            </h2>
            <div className="text-base md:text-lg text-slate-300 space-y-3 mb-6" data-id="element-272">
              <p data-id="element-273">No solo vas a aprender qué hacer.</p>
              <p className="text-white font-semibold" data-id="element-274">
                Vas a entender por qué lo estás haciendo.
              </p>
              <p data-id="element-275">Y cuando entendés eso…</p>
            </div>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-3 text-base md:text-lg font-bold" data-id="element-276">
              <div className="bg-slate-900 px-5 py-3 rounded-xl border border-slate-700 text-slate-400 w-full sm:w-auto" data-id="element-277">
                <span className="text-cyan-400 mr-2" data-id="element-278">👉</span> Dejás de
                memorizar
              </div>
              <div className="hidden sm:block text-slate-500" data-id="element-279">➔</div>
              <div className="bg-slate-900 px-5 py-3 rounded-xl border border-lime-500/50 text-white w-full sm:w-auto shadow-lg shadow-lime-500/10" data-id="element-280">
                <span className="text-lime-400 mr-2" data-id="element-281">👉</span> Empezás a decidir
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}